import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts.css';
import './i18n'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installEmailLowercase } from './lib/emailLowercase';
import { installNameCase } from './lib/nameCase';

// Emails saisis en minuscules partout (voir lib/emailLowercase.ts).
installEmailLowercase();
// Prénoms et noms : majuscule en tête de chaque mot (voir lib/nameCase.ts).
installNameCase();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
